module.exports = __webpack_public_path__ + "img/policy.e9b3dc94.svg";